import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  StudyFile,
  StudyFileUpload,
} from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';
import { MediaGroup } from 'src/app/models/media/media-group.model';
import { EventsEmitter } from '../../../../shared/event-emitter/EventEmitter';
import { ImageModalComponent } from '../image-modal/image-modal.component';

@Component({
  selector: 'app-additional-xrays',
  templateUrl: './additional-xrays.component.html',
  styleUrls: ['./additional-xrays.component.scss'],
})
export class AdditionalXraysComponent {
  @Input() studyFiles: StudyFile[] = [];
  @Input() mediaGroups: MediaGroup[] = [];
  @Input() mediaCategories: MediaCategory[] = [];
  @Input() viewonly: boolean = false;

  @Input() saleId: number;
  @Input() horseId: number;
  @Input() studyId: number;
  @Input() saleName: string = '';
  @Input() horseName: string = '';

  @Output() changeMediaCategory: EventEmitter<{
    studyFile: StudyFile;
    mediaCategoryId: number;
  }> = new EventEmitter<{ studyFile: StudyFile; mediaCategoryId: number }>();
  @Output() uploadAsAdditional: EventEmitter<{
    studyFile: StudyFile;
    isAdditional: boolean;
  }> = new EventEmitter<{ studyFile: StudyFile; isAdditional: boolean }>();
  @Output() deleteStudyFile: EventEmitter<number> = new EventEmitter<number>();

  @Output() createStudyFiles: EventEmitter<File[]> = new EventEmitter<File[]>();

  selectedFiles: File[] = [];
  constructor(
    private modalService: NgbModal,
    private readonly eventEmitter: EventsEmitter
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const studyFilesNew = changes['studyFiles'];
    if (
      studyFilesNew?.currentValue &&
      studyFilesNew?.currentValue?.length !==
        studyFilesNew?.previousValue?.length
    ) {
      this.selectedFiles.splice(0, 1);
    }
  }

  emitChangeMediaCategory(model: {
    studyFile: StudyFile;
    mediaCategoryId: number;
  }): void {
    this.changeMediaCategory.emit(model);
  }

  emitUploadAsAdditional(model: {
    studyFile: StudyFile;
    isAdditional: boolean;
  }): void {
    this.uploadAsAdditional.emit(model);
  }

  emitDeleteStudyFile(studyFileId: number): void {
    this.deleteStudyFile.emit(studyFileId);
  }

  selectFiles(files: File[]): void {
    const filesToUpload = files.map((file) => {
      const upload = {
        file: file,
        horseId: this.horseId,
        saleId: this.saleId,
        horseName: this.horseName,
        saleName: this.saleName,
        studyId: this.studyId,
        isAdditional: true,
        mediaCategoryId: null,
      } as StudyFileUpload;
      return upload;
    });

    this.eventEmitter.emitFileStartUploadEvent(filesToUpload);
    this.createStudyFiles.emit();
  }

  viewImage(data: { url: string; studyFileId: number }): void {
    const studyFile: StudyFile = this.studyFiles.filter(
      (x) => x.studyFileId === data.studyFileId
    )[0];
    //this.activityStart.emit({ studyFile, activityId: Activity.XRayView })
    const modalRef = this.modalService.open(ImageModalComponent, {
      size: '75-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.url = data.url;
    modalRef.componentInstance.studyFile = studyFile;
    modalRef.result.then(
      (result) => {
        //this.activityEnd.emit(Activity.XRayView);
      },
      (reason) => {
        //this.activityEnd.emit(Activity.XRayView);
      }
    );
  }
}
